import './Modal.scss';
import React, { ReactNode } from 'react';
import 'react-responsive-modal/styles.css';

import { Modal as ModalPkg } from 'react-responsive-modal';
import { Button, Typography } from '@design-system';

export type ModalProps = {
    open: boolean;
    setClose: () => void;
    title?: string;
    yesText?: string;
    noText?: string;
    onValidate?: () => void;
    onClose?: () => void;
    closeOnValidate?: boolean;
    setCloseOnClose?: boolean;
    children?: ReactNode;
    className?: string;
} & React.HTMLAttributes<HTMLDivElement>;

export const Modal: React.FC<ModalProps> = ({
    open,
    setClose,
    onClose,
    title,
    yesText,
    noText,
    onValidate,
    closeOnValidate = true,
    setCloseOnClose = true,
    children,
    className
}) => {
    return (
        <div>
            <ModalPkg open={open} onClose={setClose} center classNames={{modal: className}} >
                <div className="modal">
                    {title && <Typography intrinsic="h2">{title}</Typography>}

                    <div className="modal-body">{children}</div>

                    <div className="modal-footer">
                        {onValidate && (
                            <Button
                                onClick={() => {
                                    onValidate();
                                    if (closeOnValidate) {
                                        setClose();
                                    }
                                }}
                                className="validate"
                                variant="primary"
                            >
                                <Typography intrinsic="p">{yesText ?? 'Oui'}</Typography>
                            </Button>
                        )}
                        {onClose && (
                            <Button
                                onClick={() => {
                                    if (setCloseOnClose) {
                                        setClose();
                                    }
                                    onClose();
                                }}
                                className="close"
                                variant="danger"
                            >
                                <Typography intrinsic="p">{noText ?? 'Non'}</Typography>
                            </Button>
                        )}
                    </div>
                </div>
            </ModalPkg>
        </div>
    );
};
